export default __webpack_public_path__ + "static/media/cfx-cm-invoice-billing.a786d3ce.svg";